/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {useEffect, useState} from 'react'

export interface IProgressTab {
 name: string
 id: string | number
 key: string
 status?: string
 icon?: string
}

type Props = {
 activeTabId: number
 containerClass?: string
 tabHeaderContainerClass?: string
 tabHeaderClass?: string
 className?: string
 iconClass?: string
 iconActiveClass?: string
 headerActiveClass?: string
 tabBodyClass?: string
 tabContent?: React.ReactNode
 tabs?: Array<IProgressTab>
 onClick?: (value: number, isBackBtnClick: boolean) => void
}

const KTProgressTab: React.FC<Props> = ({
 containerClass,
 tabHeaderContainerClass,
 tabHeaderClass,
 iconActiveClass,
 headerActiveClass,
 iconClass,
 tabBodyClass,
 onClick,
 tabs,
 tabContent,
 activeTabId,
}) => {
 //  const [activeTabIndex, setActiveTabIndex] = useState(0)

 const handleTabClick = (tabId: number) => {
  if (onClick) onClick(tabId, true)
 }

 return (
  <div className={`${containerClass}`}>
   <ul
    className={`${tabHeaderContainerClass} line_box flex justify-center text-base font-medium`}
   >
    {tabs?.map((val: IProgressTab, key: number) => (
     <li
      key={key}
      className={`${tabHeaderClass} ${
       (val.status === 'complete' || key === activeTabId) &&
       headerActiveClass
      } text_circle text-[#4E83E4] text-[10px] font-semibold text-center flex flex-col items-center before:h-[1px] after:h-[1px] before:top-[12px] after:top-[12px]`}
      onClick={() => {
       handleTabClick(key)
      }}
     >
      <div
       className={`${iconClass} ${
        key === activeTabId
         ? '!bg-black text-white'
         : val.status === 'complete' && iconActiveClass
       } w-6 h-6 rounded-full bg-white border border-[#5A6066] flex items-center justify-center z-[1]`}
       title={val.name}
      >
       {key + 1}
      </div>
      <div className={``}>{val.name}</div>
     </li>
    ))}
   </ul>
   <div
    className={`${tabBodyClass} text-base font-medium py-2`}
   >
    {tabContent}
   </div>
  </div>
 )
}

export {KTProgressTab}
